import React, { useState, useEffect } from "react";
import { useEvent } from "@hooks/useEvent";
import { Input, Text } from "@fragments";
import { EventAvailableRounded } from "@mui/icons-material";
import EVENTS from "../events";

export default function Launch({ value, onChange }) {
    const [mode, setMode] = useState(value ? 'scheduled' : 'immediate');
    const [dateTime, setDateTime] = useState(value || '');


    const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:00`;
    };

    const getDefaultDateTime = () => {
        const now = new Date();
        now.setHours(now.getHours() + 2);
        return formatDateTime(now);
    };

    function handleModeChange(newMode) {
        if (!newMode) return;
        setMode(newMode);
        if (newMode === 'immediate') {
            setDateTime('');
            onChange(null);
        } else {
            const defaultValue = getDefaultDateTime();
            setDateTime(defaultValue);
            onChange(defaultValue);
        }
    }

    function handleDateTimeChange(val) {
        setDateTime(val);
        onChange(val || null);
    }

    const getSuggestions = () => {
        const now = new Date();

        const in6Hours = new Date(now);
        in6Hours.setHours(now.getHours() + 6);

        const tomorrowNoon = new Date(now);
        tomorrowNoon.setDate(now.getDate() + 1);
        tomorrowNoon.setHours(12, 0, 0, 0);

        const tomorrow7pm = new Date(now);
        tomorrow7pm.setDate(now.getDate() + 1);
        tomorrow7pm.setHours(19, 0, 0, 0);

        const nextWeek = new Date(now);
        nextWeek.setDate(now.getDate() + 7);
        nextWeek.setHours(19, 0, 0, 0);

        const weekdayNames = [
            { name: 'domingo', gender: 'o' },
            { name: 'segunda-feira', gender: 'a' },
            { name: 'terça-feira', gender: 'a' },
            { name: 'quarta-feira', gender: 'a' },
            { name: 'quinta-feira', gender: 'a' },
            { name: 'sexta-feira', gender: 'a' },
            { name: 'sábado', gender: 'o' }
        ];

        const dayInfo = weekdayNames[nextWeek.getDay()];
        const nextWeekLabel = `Na próxim${dayInfo.gender} ${dayInfo.name} às 19h`;

        return [
            { value: formatDateTime(in6Hours), label: "Daqui a 6 horas" },
            { value: formatDateTime(tomorrowNoon), label: "Amanhã ao meio dia" },
            { value: formatDateTime(tomorrow7pm), label: "Amanhã às 19h" },
            { value: formatDateTime(nextWeek), label: nextWeekLabel }
        ];
    };

    const suggestions = getSuggestions();

    return (
        <div className="mt-5">
            <Text.h3
                value="Data de lançamento"
                left={<EventAvailableRounded />}
                className="mb-1"
            />

            <Input.Choices
                className="mt-2 mb-2"
                value={mode}
                onInput={handleModeChange}
                options={[
                    { label: "Estréia imediata", value: "immediate" },
                    { label: "Lançar em uma data específica", value: "scheduled" }
                ]}
            />

            {mode === 'scheduled' && (
                <div className="pl-2 border-left-surface-7" style={{ borderLeft: "2px solid var(--surface-7)", marginLeft: "8px" }}>
                    <Input.DateTime
                        value={dateTime}
                        onInput={handleDateTimeChange}
                        label="Data e horário de lançamento"
                        placeholder="dd/mm/aaaa"
                        allowPast={true}
                        allowToday={true}
                        allowFuture={true}
                        suggestions={suggestions}
                    />
                </div>
            )}
        </div>
    );
}
